<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <backIndex  v-if="$route.meta.backIndex"></backIndex>
    <backTop  v-if="$route.meta.backTop"></backTop>
    <router-link to="/activityHome"
                 v-show="$route.meta.backActivity"
                 class="to-index"><img src="./assets/images/hdsy.png"
           alt=""></router-link>
  </div>
</template>

<script>
import backIndex from './components/common/backIndex';
import backTop from './components/common/backTop';
export default {
  components: {
    backIndex,
    backTop
  },
  name: "App"
};
</script>

<style lang="less">
.to-index {
  position: fixed;
  right: 12px;
  bottom: 40%;
  z-index: 100;
  img {
    width: 50px;
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, "Microsoft Yahei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  // position: relative;
  // left: 0;
  // top: 0;
  font-size: 14px;
  line-height: 1.15;
  word-break: break-all;
}
* {
  position: relative;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-decoration: none;
}
body {
  background: rgba(255, 255, 255, 1);
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
input,
textarea,
button {
  -webkit-appearance: none;
  outline: none;
}
img {
  display: block;
  width: 100%;
  height: auto;
}
input::-webkit-input-placeholder {
  color: rgba(115, 123, 145, 1);
}
input::-moz-placeholder {
  color: rgba(115, 123, 145, 1);
}
input:-moz-placeholder {
  color: rgba(115, 123, 145, 1);
}
input:-ms-input-placeholder {
  color: rgba(115, 123, 145, 1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue